<template>
    <div class="column has-text-centered">
        <nav class="pagination is-centered" role="navigation" aria-label="pagination">
            <ul class="pagination-list">
                <li><a class="pagination-link" v-if="getCurrentPage > 2" @click="changePage(getFirstPage)">{{ getFirstPage }}</a></li>
                <li><span class="pagination-ellipsis" v-if="getCurrentPage > 2">&hellip;</span></li>
                <li><a class="pagination-link" v-if="getCurrentPage > 1" @click="changePage(getCurrentPage - 1)">{{ getCurrentPage - 1 }}</a></li>
                <li><a class="pagination-link is-current" @click="changePage(getCurrentPage)">{{ getCurrentPage }}</a></li>
                <li><a class="pagination-link" v-if="getCurrentPage < getLastPage"  @click="changePage(getCurrentPage + 1)">{{ getCurrentPage + 1 }}</a></li>
                <li><span class="pagination-ellipsis" v-if="getCurrentPage + 1 < getLastPage">&hellip;</span></li>
                <li><a class="pagination-link" @click="changePage(getLastPage)" v-if="getCurrentPage + 1 < getLastPage">{{ getLastPage }}</a></li>
            </ul>
        </nav>
    </div>
</template>

<script>
    export default {
        methods: {
            changePage(value) {
                this.$store.dispatch('setProfitSectionInvoiceQueryFieldValue', {field: 'page', value: value })
                this.$store.dispatch('fetchProfitSectionInvoicesWithQuery')
            }
        },
        computed: {
            getFirstPage() {
                return this.$store.getters.getProfitSectionInvoicePagination.first_page
            },
            getCurrentPage() {
                return this.$store.getters.getProfitSectionInvoicePagination.current_page
            },
            getLastPage() {
                return this.$store.getters.getProfitSectionInvoicePagination.last_page
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/Profit/ProfitInvoiceTablePagination.vue